module.exports = __webpack_public_path__ + "static/img/bg-04.3e7f882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/bg-04.jpg
// module id = a6EK
// module chunks = 1